import { render } from "./actors.vue?vue&type=template&id=616ffbf0"
import script from "./actors.vue?vue&type=script&lang=ts"
export * from "./actors.vue?vue&type=script&lang=ts"
script.render = render

export default script